
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { languageMixin } from "@/mixins/languageMixin";
import MainHeader from "@/components/main-header.vue";
import LeftPatient from "../components/left-patient.vue";
import Empty from "@/components/empty.vue";
import PatientCard from "../components/patient-card.vue";
import TimeLine from "../components/time-line.vue";
import CepingRecord from "../components/ceping-record.vue";
import Newst from "../components/newst.vue";
import BatchPrinting from "@/components/batch-printing.vue";
@Component({
  components: {
    MainHeader,
    LeftPatient,
    Empty,
    PatientCard,
    TimeLine,
    CepingRecord,
    Newst,
    BatchPrinting,
  },
})
export default class Name extends mixins(languageMixin) {
  private ifShowBatchPrinting: any = false;
  private manageFilter: any = {};
  private cepingSelectOptions: any = {};
  private cSelect: any = [];
  private showZiwai: any = true;
  private modelData: any = [];

  private get patient() {
    return this.$store.state.patient;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private updateTimeLine() {
    (this.$refs.timeline as any).getTimeData();
  }
  private switchChange(e: any) {
    console.log("22");
    console.log(e);
    if (e) {
      // 打开紫外灯
      window.electronMyAPI.changeLight("紫外光-ON");
      this.$store.commit("updateIfShowZiwai", true);
    } else {
      // 关闭紫外灯
      window.electronMyAPI.changeLight("紫外光-OFF");
      this.$store.commit("updateIfShowZiwai", false);
    }
  }
  private changePatient() {}
  private clickCeping(item: any) {
    const index = this.getIndex(this.cSelect, item, "id");
    if (index == -1) {
      this.cSelect.push(item);
    } else {
      this.cSelect.splice(index, 1);
    }
    this.$forceUpdate();
  }
  private getIndex(arr: any, item: any, key: any) {
    const index: any = arr.findIndex((val: any) => {
      return val.id == item[key];
    });
    return index;
  }
  private changeTab(val: any) {
    this.manageFilter.cTab = val;
    localStorage.setItem("manageFilter", JSON.stringify(this.manageFilter));
  }
  private goEdit() {
    this.$router.push({
      path: "/main/patient/add",
      query: {
        id: this.patient.id,
      },
    });
  }
  private mounted() {
    const model: any = JSON.parse(
      JSON.stringify(this.systemInfo.SETTING.model)
    );
    this.modelData = [];
    model.forEach((element: any) => {
      this.modelData.push(this.systemInfo.PART[element]);
    });
    this.showZiwai = this.$store.state.ifShowZiwai;
    if (localStorage.getItem("manageFilter")) {
      this.manageFilter = JSON.parse(
        localStorage.getItem("manageFilter") as any
      );
    } else {
      this.manageFilter = {
        ifHideLeft: false, // 是否隐藏左边患者列表
        cTab: "健康概览", // 模块，健康预览或者档案记录
      };
    }
  }
}
